import { useCallback, useEffect, useState } from "react";
import { collection, addDoc, getDocs, deleteDoc, doc } from "firebase/firestore";
import { db } from "../firebase";
import "../css/Ideas.css";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faPenToSquare, faTrashAlt, faX } from "@fortawesome/free-solid-svg-icons";
import { useDispatch } from "react-redux";
import { showLoading, hideLoading } from "../../redux/actions/loadingActions";
import { mostrarError, mostrarExito, mostrarInfo } from "../utils/Alertas";
import TextField from '@mui/material/TextField';

interface Viaje {
	id: string;
	destino: string;
}

const Viajes: React.FC = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [viaje, setViaje] = useState("");
	const [viajes, setViajes] = useState<Viaje[]>([]);
	const [completados, setCompletados] = useState<Viaje[]>([]);
	const [isEditing, setIsEditing] = useState(false);

	const mostrarViajes = useCallback(async () => {
		dispatch(showLoading());
		try {
			const viajesSnapshot = await getDocs(collection(db, "Viajes"));
			const viajesList: Viaje[] = [];
			viajesSnapshot.forEach((doc) => {
				viajesList.push({ id: doc.id, destino: doc.data().destino });
			});
			setViajes(viajesList);

			const completadosSnapshot = await getDocs(collection(db, "ViajesCompletados"));
			const completadosList: Viaje[] = [];
			completadosSnapshot.forEach((doc) => {
				completadosList.push({ id: doc.id, destino: doc.data().destino });
			});
			setCompletados(completadosList);
		} catch (error) {
			console.error("Error obteniendo los viajes: ", error);
			mostrarError("Error obteniendo los viajes.");
		} finally {
			dispatch(hideLoading());
		}
	}, [dispatch]);

	const guardarViaje = async () => {
		if (!viaje.trim()) {
			mostrarInfo("Por favor, ingresa un destino.");
			return;
		}
		try {
			await addDoc(collection(db, "Viajes"), { destino: viaje });
			setViaje("");
			mostrarViajes();
			mostrarExito("Viaje guardado correctamente.");
		} catch (error) {
			console.error("Error guardando el viaje: ", error);
			mostrarError("Error guardando el viaje.");
		}
	};

	const completarViaje = async (id: string, destino: string) => {
		try {
			await addDoc(collection(db, "ViajesCompletados"), { destino });
			await deleteDoc(doc(db, "Viajes", id));
			mostrarViajes();
			mostrarExito(`El viaje "${destino}" se ha realizado con éxito.`);
		} catch (error) {
			console.error("Error completando el viaje: ", error);
			mostrarError("Error completando el viaje.");
		}
	};

	const eliminarViaje = async (id: string) => {
		try {
			await deleteDoc(doc(db, "Viajes", id));
			mostrarViajes();
			mostrarExito("Viaje eliminado correctamente.");
		} catch (error) {
			console.error("Error eliminando el viaje: ", error);
			mostrarError("Error eliminando el viaje.");
		}
	};

	useEffect(() => {
		mostrarViajes();
	}, [mostrarViajes]);

	return (
		<div className="container-fluid">
			<div className="text-center">
				<h2 className="pb-3">Lista de Viajes</h2>
			</div>

			<div className="container-fluid content pb-3">
				<form onSubmit={(e) => { e.preventDefault(); guardarViaje(); }}>
					<div className="input-group" style={{ marginBottom: 0 }}>
						<TextField
                            id="viaje"
                            label="Ingresa un destino"
                            value={viaje}
                            onChange={(e) => setViaje(e.target.value)}
                            fullWidth
                            margin="normal"
                            style={{ marginTop: 0 }}
                        />
					</div>
					<button className="main-button" type="submit">Guardar Viaje</button>
				</form>

				{viajes.length > 0 && (
					<div className="list" id="comidaList">
						<div className="list-header">
							<h3>Viajes Pendientes / Ideas</h3>
							{isEditing ? (
								<FontAwesomeIcon
									className="edit-button"
									onClick={() => setIsEditing(false)}
									icon={faX}
								/>
							) : (
								<FontAwesomeIcon
									className="edit-button"
									onClick={() => setIsEditing(true)}
									icon={faPenToSquare}
								/>
							)}
						</div>
						<ul id="comidaItems">
							{viajes.map((item) => (
								<li key={item.id} className="idea-item">
									<span>{item.destino}</span>
									{isEditing && (
										<div className="buttons">
											<button className="complete-button">
												<FontAwesomeIcon
													onClick={() => completarViaje(item.id, item.destino)}
													icon={faCheck}
												/>
											</button>
											<button className="delete-button">
												<FontAwesomeIcon
													onClick={() => eliminarViaje(item.id)}
													icon={faTrashAlt}
												/>
											</button>
										</div>
									)}
								</li>
							))}
						</ul>
					</div>
				)}

				{completados.length > 0 && (
					<div className="text-center ideas-completadas">
						<button
							className={viajes.length > 0 ? "btn-viajes-completados-1" : "btn-viajes-completados-2"}
							onClick={() => navigate("/viajes-completados")}
						>
							Viajes Completados
						</button>
					</div>
				)}
			</div>
		</div>
	);
};

export default Viajes;
